import { resolveIdDescriptor, resolveMinMax, resolveMinMaxDescription } from '../../../../../../util/searchParamNameUtils';

export const resolveSearchParameters = ({
  params: {
    id,
    minId,
    maxId,
    minYear,
    maxYear,
    region,
    country,
    minLatitude,
    maxLatitude,
    volcanoNames,
    morphology,
    minVei,
    maxVei,
    minDeaths,
    maxDeaths,
    minDeathsAmountOrder,
    maxDeathsAmountOrder,
    minDamageMillionsDollars,
    maxDamageMillionsDollars,
    minDamageAmountOrder,
    maxDamageAmountOrder,
    assocEq,
    assocTsu,
    nameStart,
    nameInclude,
    nameMatch,
    nameNot,
    locStart,
    locInclude,
    locMatch,
    locNot,
    commentsStart,
    commentsEnd,
    commentsInclude,
    commentsMatch,
    commentsNot,
    year,
    locId,
    locPreviousNum,
    locNum,
    eruption,
  },
  regions,
  peopleDescriptors,
  damageDescriptors,
}) => {
  const messages = [];

  if (id != null) {
    messages.push(`ID = ${id}`);
  }

  resolveMinMax('ID', minId, maxId, messages);
  resolveMinMax('Year', minYear, maxYear, messages);

  if (region != null) {
    messages.push(`Region = ${resolveIdDescriptor(regions, region)}`);
  }

  if (country != null) {
    messages.push(`Country = ${country}`);
  }

  if (locStart != null) {
    messages.push(`Location starts with '${locStart}'`);
  }

  if (locMatch != null) {
    messages.push(`Location = '${locMatch}'`);
  }

  if (locInclude != null) {
    messages.push(`Location contains '${locInclude}'`);
  }

  if (locNot != null) {
    messages.push(`Location != '${locNot}'`);
  }

  if (nameStart != null) {
    messages.push(`Name starts with '${nameStart}'`);
  }

  if (nameMatch != null) {
    messages.push(`Name = '${nameMatch}'`);
  }

  if (nameInclude != null) {
    messages.push(`Name contains '${nameInclude}'`);
  }

  if (nameNot != null) {
    messages.push(`Name != '${nameNot}'`);
  }

  resolveMinMax('Latitude', minLatitude, maxLatitude, messages);

  if (volcanoNames != null) {
    messages.push(`Volcano Name = ${volcanoNames}`);
  }

  if (morphology != null) {
    messages.push(`Volcano Type = ${morphology}`);
  }

  if (assocEq != null) {
    messages.push(`Has associated earthquake = ${assocEq}`);
  }

  if (assocTsu != null) {
    messages.push(`Has associated tsunami = ${assocTsu}`);
  }

  resolveMinMax('VEI', minVei, maxVei, messages);

  resolveMinMax('Deaths', minDeaths, maxDeaths, messages);
  resolveMinMaxDescription('Deaths Description', minDeathsAmountOrder, maxDeathsAmountOrder, peopleDescriptors, messages);
  resolveMinMax('Damage Millions $', minDamageMillionsDollars, maxDamageMillionsDollars, messages);
  resolveMinMaxDescription('Damage Description', minDamageAmountOrder, maxDamageAmountOrder, damageDescriptors, messages);

  if (commentsStart != null) {
    messages.push(`Comments start with '${commentsStart}'`);
  }

  if (commentsMatch != null) {
    messages.push(`Comments = '${commentsMatch}'`);
  }

  if (commentsInclude != null) {
    messages.push(`Comments contains '${commentsInclude}'`);
  }

  if (commentsNot != null) {
    messages.push(`Comments != '${commentsNot}'`);
  }

  if (commentsEnd != null) {
    messages.push(`Comments end with '${commentsEnd}'`);
  }

  if (year != null) {
    messages.push(`Year = '${year}'`);
  }

  if (locId != null) {
    messages.push(`Location NCEI ID = '${locId}'`);
  }

  if (locPreviousNum != null) {
    messages.push(`Previous Volcano Number '${locPreviousNum}'`);
  }

  if (locNum != null) {
    messages.push(`Volcano Number '${locNum}'`);
  }

  if (eruption != null) {
    messages.push(`Oceanic Tsunami = ${eruption}`);
  }
  return messages;
};
